/**
 * Immutable Singleton UserIdentity contains information about the user's idenity.
 *
 * attributes:
 *  authenticated: String, whether the user has authenticated
 *  id: Optional Number, the user's id (if authenticated)
 *  full_name: Optional String, the user's full name (if authenticated)
 *  email_address: Optional String, the user's email (if authenticated)
 */
import Backbone from 'backbone';
import _ from 'lodash';
import Q from 'q';

import API from 'js/lib/api';

import { config } from 'bundles/phoenix/constants';
import userJson from 'bundles/user-account/common/user';

const api = API('/api', { type: 'rest' });

const UserIdentity = Backbone.Model.extend({
  hasProfile() {
    return this.get('privacy') !== -1 && this.has('external_id');
  },

  getProfileUrl() {
    const url = this.hasProfile() ? 'user/' + this.get('external_id') : 'account-profile';
    return config.dir.home + url;
  },

  // Parses the user.json returned by django.
  parse(userJsonData: $TSFixMe) {
    if (_.isEmpty(userJsonData)) {
      // user is not authenticated
      return {
        authenticated: false,
      };
    } else {
      // user is authenticated
      return _.extend(
        _.pick(userJsonData, [
          'display_name',
          'email_address',
          'external_id',
          'full_name',
          'id',
          'is_superuser',
          'privacy',
          'photo',
          'photo_120',
          'email_verified',
          'generated_password',
        ]),
        {
          authenticated: true,
        }
      );
    }
  },

  /**
   * Can be used to update the user identity without refreshing the page.
   */
  update() {
    const deferred = Q.defer();
    Promise.resolve(
      api
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'origin' does not exist on type 'UrlConfi... Remove this comment to see the full error message
        .get(config.url.origin + 'api/user/info')
    )
      .then(
        function (userData: $TSFixMe) {
          // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
          this.set(this.parse(userData));
          // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
          deferred.resolve(this);
        }.bind(this)
      )
      .catch(function (err) {
        deferred.reject(err);
      });

    return deferred.promise;
  },
});

const userIdentitySingleton = new UserIdentity(userJson, {
  parse: true,
});
export default userIdentitySingleton;
